interface StatsCardProps {
  title: string;
  value: string;
  total?: string;
  icon: string;
  color: string;
  trend: string;
  trendUp: boolean;
  isLoading?: boolean;
}

export default function StatsCard({ title, value, total, icon, color, trend, trendUp, isLoading }: StatsCardProps) {
  if (isLoading) {
    return (
      <div className="bg-white rounded-2xl p-6 border border-slate-200">
        <div className="animate-pulse">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 ${color} rounded-xl opacity-50`}></div>
            <div className="w-16 h-6 bg-slate-200 rounded-lg"></div>
          </div>
          <div>
            <div className="h-4 bg-slate-200 rounded w-24 mb-2"></div>
            <div className="h-8 bg-slate-200 rounded w-20"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-4 sm:p-6 border border-slate-200 hover:shadow-lg transition">
      <div className="flex items-start justify-between mb-3 sm:mb-4">
        <div className={`w-10 h-10 sm:w-12 sm:h-12 ${color} rounded-xl flex items-center justify-center flex-shrink-0`}>
          <i className={`${icon} text-xl sm:text-2xl text-white`}></i>
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
          trendUp ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
        }`}>
          <i className={`${trendUp ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
          <span>{trend}</span>
        </div>
      </div>
      <div>
        <h3 className="text-slate-500 text-xs sm:text-sm font-medium mb-1">{title}</h3>
        <div className="flex items-baseline gap-2">
          <p className="text-2xl sm:text-3xl font-bold text-slate-800">{value}</p>
          {total && <span className="text-slate-400 text-xs sm:text-sm">{total}</span>}
        </div>
      </div>
    </div>
  );
}
